import React, { useState } from 'react';
import { productsByCat, bundlesByCat, getCatalogNumber, getName, makeProductImageObjects } from '../utils/utils';
import {
  Button,
  Box,
  Text,
  Header,
  Container,
  Row,
  Column,
  Img,
  variables,
  space,
} from '@generationtux/component-library';
import styled from 'styled-components';

const THUMBNAIL_MAX_WIDTH = 24;

const TableMePretty = styled.table`
  border-collapse: collapse;
  th {
    text-align: left;
    font-weight: normal;
    color: ${props => variables(props).grayDark};
  }
  tr:nth-child(2n + 1) {
    background-color: ${props => variables(props).grayLighter};
  }
  td,
  th {
    padding: 2px ${space[1]}px;
  }
`;
const DataPage = () => {
  const data = { ...productsByCat, ...bundlesByCat };
  const [activeCategory, setActiveCategory] = useState(Object.keys(data)[0]);

  return (
    <Text small as="div">
      <Container mt={4}>
        <Row flexWrap>
          <Column column={12}>
            <Box mb={4}>
              <Header type={1} size={4}>
                Look Builder Assets
              </Header>
              {Object.keys(data).map(cat => (
                <Button key={cat} size="xs" onClick={() => setActiveCategory(cat)} mr={1} mb={1}>
                  {cat} &nbsp;{' '}
                  <Text as="span" size="xs" textColor="grayDark">
                    {data[cat].length}
                  </Text>
                </Button>
              ))}
            </Box>
            <Box mb={4}>
              {Object.keys(data)
                .filter(cat => cat === activeCategory)
                .map(cat => {
                  return (
                    <Box mb={4} key={cat}>
                      <Header type={2} size={5} mb={2}>
                        {cat.toUpperCase()} - {data[cat].length}
                      </Header>

                      <TableMePretty style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Catalog Number</th>
                            <th>Legacy Images</th>
                            <th>Prototype Images</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data[cat].map((product, index) => {
                            const isBundle = product.bundleId ? true : false;
                            const catalogNumber = isBundle
                              ? product.products.map(x => getCatalogNumber(x)).join(', ')
                              : getCatalogNumber(product);
                            const catalogName = getName(product);

                            // build dem layers
                            let layers = makeProductImageObjects(
                              isBundle ? product.products.filter(x => x.type === 'Jacket')[0] : product
                            );

                            // get the pants too
                            if (
                              isBundle &&
                              layers &&
                              product.products.filter(x => x.type === 'Pant' || x.type === 'Pants')[0]
                            ) {
                              layers = [
                                ...layers,
                                ...makeProductImageObjects(
                                  product.products.filter(x => x.type === 'Pant' || x.type === 'Pants')[0]
                                ),
                              ];
                            }

                            return (
                              <tr key={product.catalogNumber + catalogName + index}>
                                <td>{index + 1}</td>
                                <td>{catalogName}</td>
                                <td>{catalogNumber}</td>
                                <td>
                                  {product.media.filter(elm => elm.label.includes('VIS')).length < 1 && (
                                    <Text small textColor="gray" mr={2}>
                                      none
                                    </Text>
                                  )}
                                  {product.media
                                    .filter(elm => elm.label.includes('VIS'))
                                    .map(elm => {
                                      return (
                                        <Box
                                          display="inline-block"
                                          mr={2}
                                          key={elm.url}
                                          p={1}
                                          backgroundColor={'danger'}
                                        >
                                          <Img
                                            src={`${elm.url}?w=${THUMBNAIL_MAX_WIDTH}`}
                                            alt={`${catalogNumber} - ${elm.label}`}
                                            maxWidth={THUMBNAIL_MAX_WIDTH}
                                            style={{ width: THUMBNAIL_MAX_WIDTH }}
                                          />
                                        </Box>
                                      );
                                    })}
                                </td>
                                <td>
                                  {layers &&
                                    layers.map(layer => {
                                      return (
                                        <Box
                                          display="inline-block"
                                          mr={2}
                                          key={layer.url}
                                          p={1}
                                          backgroundColor={'green'}
                                        >
                                          <Img
                                            src={`${layer.url}?w=${THUMBNAIL_MAX_WIDTH}`}
                                            alt={`${catalogNumber} - ${layer.layerName}`}
                                            maxWidth={THUMBNAIL_MAX_WIDTH}
                                            style={{ width: THUMBNAIL_MAX_WIDTH }}
                                          />
                                        </Box>
                                      );
                                    })}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </TableMePretty>
                    </Box>
                  );
                })}
            </Box>
          </Column>
        </Row>
      </Container>
    </Text>
  );
};

export default DataPage;
